import { phoneNumberField } from "toptaal-shared"
import { z } from "zod"

export const studentPersonalInfoSchema = z.object({
  phoneNumberCall: phoneNumberField,
  phoneNumberWhatsapp: phoneNumberField,

  samePhone: z.boolean().optional().default(true),
})

export type StudentPersonalInfo = z.infer<typeof studentPersonalInfoSchema>

export const studentContactPersonInfoSchema = z.object({
  phoneNumberTranslator: z.string().nullable().optional(),
  contactPersonRelationship: z.string().nullable(),
})

export type StudentContactPersonInfo = z.infer<
  typeof studentContactPersonInfoSchema
>
